var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.VerificationOfEstimatedProfitMargin"),
        width: "500px",
        "show-close": false,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "10px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "150px",
                "label-position": "left"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("Message.EstimatedIncome") +
                          "(" +
                          _vm.$t("Message.EquivalentToRMB") +
                          ")"
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          disabled: !_vm.editable,
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          controls: false
                        },
                        on: { change: _vm.calcuProfit },
                        model: {
                          value: _vm.job.estimateAccountsReceivable,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimateAccountsReceivable", $$v)
                          },
                          expression: "job.estimateAccountsReceivable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("Message.EstimatedCost") +
                          "(" +
                          _vm.$t("Message.EquivalentToRMB") +
                          ")"
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          disabled: !_vm.editable,
                          min: -999999999999,
                          max: 999999999999,
                          precision: 2,
                          controls: false
                        },
                        on: { change: _vm.calcuProfit },
                        model: {
                          value: _vm.job.estimateAccountsPayable,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "estimateAccountsPayable", $$v)
                          },
                          expression: "job.estimateAccountsPayable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Message.EstimatedProfit") } },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumberToThousands(
                              _vm.job.estimateGrossProfit.toFixed(2),
                              2
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _c("br"),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("Message.EstimatedProfitMargin") }
                    },
                    [_c("label", [_vm._v(_vm._s(_vm.grossProfitTxt))])]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Message.EstimatedRemarks") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.job.situation,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "situation", $$v)
                          },
                          expression: "job.situation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editable,
                      expression: "!editable"
                    }
                  ]
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm
                        .$t("queryJob.EstimatedProfitNotCompanyRegulations")
                        .replace("{0}", "(0 ~ " + _vm.estimateProfitRate + "%)")
                    )
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.confirm }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }